const state = {
  toasts: []
};

const getters = {
  toasts: state => state.toasts
};

const mutations = {
  setToast: (state, payload) => state.toasts.push(payload),
  removeToast: state => state.toasts.shift()
};

const actions = {
  removeToast: ({ commit }) => {
    commit("removeToast");
  },
  showToast: ({ commit }, payload) => {
    const inArray = state.toasts.find(el => el.message === payload.message);

    if (!inArray) {
      commit("setToast", payload);
      setTimeout(() => commit("removeToast"), 5000);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
